import React from 'react';
import { Button } from '@mui/material';

/** Text-style destructive action (e.g. Delete in dialogs). */
const DangerTextButton = React.forwardRef(function DangerTextButton(props, ref) {
  return <Button ref={ref} variant="text" color="error" {...props} />;
});

export default DangerTextButton;
